import { Stack } from '@mui/material';
import { styled } from '@mui/system';

const StyledStack = styled(Stack)(({ theme }) => ({
	'&.MuiStack-root': {
		justifyContent: "center",
		alignItems: "center",
		border: "1px solid " + theme.palette.grey[400],
		borderRadius: theme.spacing(0.5),
		padding: "0.438rem 1rem",
		'.MuiInputLabel-shrink': {
			backgroundColor: "#fff",
			paddingLeft: theme.spacing(0.5),
			paddingRight: theme.spacing(0.5),
		},
		'.semDestaque': { color: theme.palette.text.disabled },
	},
	'&.MuiStack-root:hover': { borderColor: theme.palette.grey[900] },
 }));

export default StyledStack;
